module.exports = __webpack_public_path__ + "img/two_people.d6949f55.svg";